import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "../utils/i18n";

function Footer() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        backgroundColor: "#0D1117",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        color: "#fff",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Container
        sx={{
          width: { xs: "100%", md: "70%" },
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src="/images/logo/SMD_logo_inverted.svg"
              alt="RadioSMD"
              sx={{ height: 48, width: "auto", objectFit: "contain" }}
            />

            <Typography variant="body2" sx={{ mt: 2, color: "#9AA4B2" }}>
              {t("footer.tagline")}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 1, mt: 2 }}
            >
              {t("footer.quickLinks")}
            </Typography>
            <Stack spacing={1}>
              <Link
                component={RouterLink}
                to="/products"
                underline="hover"
                color="inherit"
              >
                {t("nav.products")}
              </Link>
              <Link
                component={RouterLink}
                to="/about"
                underline="hover"
                color="inherit"
              >
                {t("nav.about")}
              </Link>
              <Link
                component={RouterLink}
                to="/news"
                underline="hover"
                color="inherit"
              >
                {t("nav.news")}
              </Link>
              <Link
                component={RouterLink}
                to="/contact"
                underline="hover"
                color="inherit"
              >
                {t("nav.contact")}
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="body2"
              component="a"
              href="mailto:info@radiosmd.se"
              sx={{
                color: "#9AA4B2",
                textDecoration: "none",
                display: "block",
                "&:hover": { color: "#fff" },
                mt: 2,
              }}
            >
              info@radiosmd.se
            </Typography>
            <Typography
              variant="body2"
              component="a"
              href="tel:+46523166100"
              sx={{
                color: "#9AA4B2",
                textDecoration: "none",
                display: "block",
                mt: 1,
                "&:hover": { color: "#fff" },
              }}
            >
              +46 (0) 523 166 10
            </Typography>
            <Typography variant="body2" sx={{ color: "#9AA4B2", mt: 1 }}>
              Södra Hamngatan 16, 453 33 Lysekil
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <IconButton
                aria-label="facebook"
                component="a"
                href="https://www.facebook.com/RadioSMD"
                target="_blank"
                rel="noreferrer"
                sx={{ color: "#9AA4B2", "&:hover": { color: "#fff" } }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                aria-label="linkedin"
                component="a"
                href="https://se.linkedin.com/company/radiocontrol-smd-ab"
                target="_blank"
                rel="noreferrer"
                sx={{ color: "#9AA4B2", "&:hover": { color: "#fff" } }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                aria-label="youtube"
                component="a"
                href="https://www.youtube.com/@radiocontrolsmdab7853"
                target="_blank"
                rel="noreferrer"
                sx={{ color: "#9AA4B2", "&:hover": { color: "#fff" } }}
              >
                <YouTubeIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: "1px solid rgba(255,255,255,0.08)",
            mt: 4,
            pt: 3,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography variant="caption" sx={{ color: "#9AA4B2" }}>
            © {new Date().getFullYear()} RadioControl SMD AB.{" "}
            {t("footer.copyright")}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.6 }}>
            Built by{" "}
            <Box
              component="a"
              href="https://gammalldev.netlify.app"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "inherit", textDecoration: "underline" }}
            >
              Felix Gammal
            </Box>{" "}
            · Creative Design & Content by Philip R. Larka
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
